import { lazy } from '@/service/lazy'

export default [{
  name: 'Campanhas',
  path: 'campanha',
  id: 'campanha',
  icon: 'fa fa-list',
  component: lazy('app/default/listagem/index'),
  meta: { requireAuth: true, rules: ['gerenciar_lista'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/listagem.js